import { RealtimeRole } from '@doxyme/realtime';
import { type RoomForPatient } from '../../services';
import { type WaitingMember } from '../../shared/waitingMember';
import { RealtimeMemberStatus } from '../../features/realtime/realtime.types';

/**
 * Returns the default provider data for the patient view waiting room.
 * Used when provider is offline.
 */
export const getWaitingOfflineProvider = (
  waitingRoom: RoomForPatient,
  username: string,
): WaitingMember => {
  const id = waitingRoom.roomAdmin.id.toString();

  return {
    id,
    state: {
      status: RealtimeMemberStatus.Offline,
      username,
    },
    roomId: waitingRoom.id,
    identity: {
      id,
      role: RealtimeRole.Provider,
    },
    picture: waitingRoom.roomAdmin.userProfilePictureUrl || undefined,
    chatUserId: '0',
    joinedAt: 0,
  };
};
